import React from 'react'

import { Heading } from 'goustouicomponents'

import { completeWizardBoxSize } from 'actions/trackingKeys'
import { RibbonTriggerContainer } from 'components/RibbonTrigger'
import { NumberOfPortions, useBasket } from 'routes/Menu/domains/basket'
import { signupConfig } from 'routes/Signup/signupConfig'

import { GoustoOnDemandBoxSizeContent } from './GoustoOnDemandBoxSizeContent'
import { PrimaryButton } from './PrimaryButton'
import { BoxDescriptionPlaceholderType } from './types'

import signupCss from '../../Signup.css'
import css from './BoxSizeStep.css'

type BoxSizeStepProps = {
  numPortionChange: (value: NumberOfPortions) => void
  numPortionChangeTracking: (value: NumberOfPortions) => void
  next: () => void
  trackSignupWizardAction: (type: string, options: { [key: string]: any }) => void
  isGoustoOnDemandEnabled: boolean
  numPersonsToBoxDescriptors: { [key: string]: BoxDescriptionPlaceholderType[] }
  isLoadingPrices: boolean
  goustoOnDemandCustomText: string
}

export const BoxSizeStep = ({
  numPortionChange,
  numPortionChangeTracking,
  next,
  trackSignupWizardAction,
  isGoustoOnDemandEnabled,
  numPersonsToBoxDescriptors,
  isLoadingPrices,
  goustoOnDemandCustomText,
}: BoxSizeStepProps) => {
  const { boxSizeTypes, title } = signupConfig.boxSizeStep
  const { setNumPortions } = useBasket()

  const handlePrimaryButtonClick = (value: NumberOfPortions) => {
    numPortionChange(value)
    numPortionChangeTracking(value)
    setNumPortions(value)
    trackSignupWizardAction(completeWizardBoxSize, {
      box_size: value,
    })
    next()
  }

  const renderCarouselItems = () =>
    boxSizeTypes.map(
      ({
        heading,
        suitableFor,
        recipeInfoTextStart,
        recipeInfoStrongText,
        recipeInfoTextEnd,
        ctaText,
        value,
      }) => (
        <div className={css.carouselItem} key={`box-size-for-${value}`}>
          <h2 className={css.itemHeading}>{heading}</h2>
          <p className={css.suitableTitle} data-testid="suitableTitle">
            <span>{recipeInfoTextStart}</span>
            <strong>{recipeInfoStrongText}</strong>
            <span>{recipeInfoTextEnd}</span>
          </p>
          <p className={css.suitableTitle}>Suitable for:</p>
          <ul className={css.list}>
            {suitableFor.map((label) => (
              <li key={`for-${label.charAt(0)}`} className={css.listItem}>
                {label}
              </li>
            ))}
          </ul>
          <PrimaryButton
            value={value}
            onPrimaryButtonClick={handlePrimaryButtonClick}
            ctaText={ctaText}
          />
        </div>
      ),
    )

  return (
    <div className={signupCss.stepContainer} data-testing="signupBoxSizeStep">
      <div className={signupCss.fullWidth}>
        <div className={signupCss.header}>
          <Heading type="h1">{title}</Heading>
        </div>
        {isGoustoOnDemandEnabled ? (
          <GoustoOnDemandBoxSizeContent
            onPrimaryButtonClick={handlePrimaryButtonClick}
            numPersonsToBoxDescriptors={numPersonsToBoxDescriptors}
            isLoadingPrices={isLoadingPrices}
            goustoOnDemandCustomText={goustoOnDemandCustomText}
          />
        ) : (
          <div className={css.boxSizeInner}>{renderCarouselItems()}</div>
        )}
      </div>
      <RibbonTriggerContainer name="wizard-box-size" />
    </div>
  )
}
